export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M.028 16 16 .028 31.972 16 16 31.972.028 16z\"/></svg>";